import { createSlice } from '@reduxjs/toolkit';
import { ResetPasswordTypeProps } from './types';

export const initialState: ResetPasswordTypeProps = {
  fetching: false,
  loginError: false,
};

export const resetPassword = createSlice({
  name: 'resetPassword',
  initialState,
  reducers: {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    getResetPasswordRequest(state, _action) {
      state.fetching = true;
      state.loginError = false;
    },
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    getResetPasswordSuccess(state, action) {
      state.fetching = false;
      state.loginError = false;
    },
    getResetPasswordError(state, action) {
      state.fetching = false;
      state.loginError = action.payload;
    },
  },
  extraReducers: {},
});

export const { actions } = resetPassword;

export default resetPassword.reducer;
